import { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Button, Portal, Segment } from 'semantic-ui-react';
import {
  removeSelectedItemsToCancelAddAdmin,
  selectedItemsToCancelAddAdminVar
} from 'utils/cache/calendar';
import { BulkCancelPopupWrapper } from './style';

interface Props {
  setIsCancelAddAdminModalOpen: (open: boolean) => void;
}

const BulkCancelPopup = ({ setIsCancelAddAdminModalOpen }: Props) => {
  const selectedItemsToCancelAddAdmin = useReactiveVar(
    selectedItemsToCancelAddAdminVar
  );

  const onClickNevermind = useCallback(() => {
    removeSelectedItemsToCancelAddAdmin();
  }, []);

  const onClickCancelAddAdmin = useCallback(() => {
    setIsCancelAddAdminModalOpen(true);
  }, [setIsCancelAddAdminModalOpen]);

  return (
    <Portal open={selectedItemsToCancelAddAdmin.size > 0}>
      <BulkCancelPopupWrapper>
        <Segment className="cancel-popup-segment" style={{ maxWidth: '700px' }}>
          <p>
            Would you like to cancel (
            <span>{selectedItemsToCancelAddAdmin.size}</span> ) and add admin
            appointment(s)
          </p>
          <Button
            content="Nevermind"
            basic
            color="grey"
            onClick={onClickNevermind}
          />
          <Button
            //className="button"
            content="Yes, Cancel and Add Admin"
            negative
            onClick={onClickCancelAddAdmin}
            style={{ maxWidth: 'unset' }}
          />
        </Segment>
      </BulkCancelPopupWrapper>
    </Portal>
  );
};

export default BulkCancelPopup;
